import { AxiosError } from "axios";

type TracesBusinessError = {
  id?: string;
  message?: string;
  field?: string;

  providedValue?: string;
  sequence?: string;
  lineDescription?: string;
  cnCode?: string;

  productId?: number;
  cnCodePS?: string;
  cnCodeCC?: string;
};

type TracesBadRequest = { message?: string; errors?: TracesBusinessError[] };

export function getNiceErrorMessage(
  err: unknown,
  opts?: { maxErrors?: number }
): { status?: number; message?: string } {
  const ax = err as AxiosError<any>;
  const status = ax.response?.status;
  const maxErrors = opts?.maxErrors ?? 3;

  const data = ax.response?.data as TracesBadRequest | string | undefined;

  // 400: TRACES/business validation (multiline)
  if (status === 400) {
    if (typeof data === "string") {
      return { status, message: data };
    }

    if (data && typeof data === "object") {
      const top = (data.message ?? "Gögn eru ekki gild.").trim();

      const lines = (data.errors ?? [])
        .slice(0, maxErrors)
        .map((e) => {
          const id = e.id ? `[${e.id}] ` : "";
          const msg = e.message ?? "Óþekkt villa";

          const details: string[] = [];

          if (e.providedValue) details.push(`  Gildi: ${e.providedValue}`);
          if (e.sequence) details.push(`  Lína: ${e.sequence}`);
          if (e.lineDescription) details.push(`  Tegund: ${e.lineDescription}`);
          if (e.cnCode) details.push(`  CN (úr línu): ${e.cnCode}`);

          if (e.productId != null) details.push(`  productId: ${e.productId}`);
          if (e.cnCodePS) details.push(`  cnCodePS: ${e.cnCodePS}`);
          if (e.cnCodeCC) details.push(`  cnCodeCC: ${e.cnCodeCC}`);

          if (e.field) details.push(`  Slóð: ${e.field}`);

          return `• ${id}${msg}${details.length ? `\n${details.join("\n")}` : ""}`;
        });

      return { status, message: [top, ...lines].join("\n") };
    }

    return { status, message: "Gögn eru ekki gild (400)." };
  }

  // 500+: keep generic
  if (status && status >= 500) return { status, message: "Villa kom upp!" };

  // Other statuses
  if (typeof data === "string" && data.trim()) return { status, message: data.trim() };

  return { status, message: status ? `Villa kom upp (${status}).` : "Villa kom upp!" };
}

export default getNiceErrorMessage;